import { Component, Input, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApplicationSectionBaseComponent } from '../../../../../applications/components/application-section-base/application-section-base.component';
import { ApplicationState, WorkflowData } from '../../../../../applications/models/applications.models';
import { DomainDefinitionService } from '../../../../../builder/services/domain-definition.service';
import { Well } from '../../../../../common/models/well.model';
import { FormationModel } from '../../../../../form-controls/components/new-casing-plan/models/casing-plan.model';
import { AuthService } from '../../../../../services/auth.service';

@Component({
    selector: 'app-completion-information',
    templateUrl: './completion-information.component.html',
    styleUrls: ['./completion-information.component.scss', '../../../../../core/components/collapsible/collapsible.component.scss'],
    standalone: false
})
export class CompletionInformationComponent extends ApplicationSectionBaseComponent implements OnInit {
    @Input() application: WorkflowData;
    @Input() formations: FormationModel[];
    @Input() well: Well;


    get productionDate(): Date {
        if (this.form == null) return null;
        let ctrl = this.form.get('productionDate');
        if (ctrl == null) return null;
        let value: Date = (ctrl.value != null && ctrl.value != '') ? new Date(ctrl.value) : null;
        return value;
    }

    get dateTreated(): Date {
        if (this.form == null) return null;
        let ctrl = this.form.get('dateTreated');
        if (ctrl == null) return null;
        let value: Date = (ctrl.value != null && ctrl.value != '') ? new Date(ctrl.value) : null;
        return value;
    }

    get producingFormation(): String {
        if (this.form == null) return null;
        let ctrl = this.form.get('prodFormation');
        if (ctrl == null) return null;
        else return this.form.get('prodFormation').value
     
    }

    get isInternal(): boolean {
        return this._auth.User.isInternal;
    }

    subscription: Subscription = new Subscription();

    blankFormation: FormationModel = {
        code: "",
        definition: "",
        isActive: true,
        isRequired: false,
        lastModifiedDateUTC: new Date
        }


    reviewStates: ApplicationState[] = [
        ApplicationState.VerifyCompletion,
        ApplicationState.InitialReview,
        ApplicationState.InitialApproval,
        ApplicationState.FinalApproval
    ];

    constructor(public _auth: AuthService, public domainService: DomainDefinitionService) {
        super(_auth); }

    ngOnInit() {
       
        let obs$: Observable<FormationModel[]> = this.domainService.getFormations().pipe(
            tap((models: FormationModel[]) => {
                this.formations = models;
                this.formations.unshift(this.blankFormation);
             
            })

        );


        let subs$: Subscription = obs$.subscribe()
        this.subscription.add(subs$);

        if (this.application != null) {
      

            if (this.application.applicationState == (ApplicationState.InitialReview || ApplicationState.Approved)) {
                this.form.disable()
            }

            if (this.isInternal && this.application.applicationState == ApplicationState.Corrections) {
                this.form.disable();
            }

            this.form.get("productionDate").setValue(this.application.workflowFieldDatas.find(f => f.formControlName == 'completionInfo|productionDate').dateData);
            this.form.get("dateTreated").setValue(this.application.workflowFieldDatas.find(f => f.formControlName == 'completionInfo|dateTreated').dateData);

           
     
        }
  }

    onOpenHoleChecked(event: Event): void {
        this.form.get("openHole").setValue(event.target['checked']);
    }

    onThruCasingChecked(event: Event): void {
        this.form.get("thruCasing").setValue(event.target['checked']);

    }

    onSlottedLinerChecked(event: Event): void {
        this.form.get("slottedLiner").setValue(event.target['checked']);

    }

    onDateUpdated(date: Date, field: string): void {
        let ctrl = this.form.get(field);
        if (ctrl != null) ctrl.setValue(date);
    }

    onSwabPitChecked(event: Event): void {
        this.form.get("swabPit").setValue(event.target['checked']);

    }

    onSwabFracChecked(event: Event): void {
        this.form.get("swabFrac").setValue(event.target['checked']);

    }

    onFlowPitChecked(event: Event): void {
        this.form.get("flowPit").setValue(event.target['checked']);

    }

    onFlowFracChecked(event: Event): void {
        this.form.get("flowFrac").setValue(event.target['checked']);

    }


}
